import React from 'react';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import Navbar from './components/Navbar';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import Home from './components/Home';
import Job from './components/Job';
import Tutorial from './components/Tutorial';
import EmailVerified from './components/EmailVerified';
import { useAuth } from './AuthContext';
import { useNotifications } from './NotificationContext';

const App = () => {
  const { loading } = useAuth();
  const { messages } = useNotifications();
  if (loading) {
    return <p></p>;
  }
  return (
    <Router basename='/mhcattention'>
      <Navbar />
      <div id="notifications">
        {messages.map((message, i) => <div key={i} className={message.type + " message"}>{message.text}</div>)}
      </div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tutorial" element={<Tutorial />} />
        <Route path="/jobs/:id" element={<Job />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/email_verified" element={<EmailVerified />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
